import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-loading-value',
  template: `
    <i [ngClass]="icon + ' ' + spinStyle" *ngIf="loading"></i>
    <ng-container *ngIf="!loading">{{ value }}</ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingValueComponent {
  @Input()
  icon = 'far fa-spinner'

  @Input()
  spinStyle = 'fa-spin'

  @Input()
  value: any

  @Input() loading = true
}
